import { UspCardProps, UI_UspCard } from 'ui/components/2-molecules/Card/UspCard/UspCard';
import styles from './UspList.module.scss';
import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';

export interface UspListProps {
	heading?: string;
	items: UspCardProps[];
}

export const UI_UspList = ({ heading, items }: UspListProps) => {
	return (
		<div className={styles.UspList}>
			{heading && (
				<UI_Heading className={styles.UspList_heading} headingLevel="h2" style="smd">
					{heading}
				</UI_Heading>
			)}
			<div className={styles.UspList_gridWrapper}>
				<UI_Grid className={styles.UspList_grid} rowGap container>
					{items.map((item, index) => (
						<UI_GridCell key={index} className={styles.UspList_item} mobileWidth="100" desktopWidth="33">
							<UI_UspCard {...item} number={index + 1} />
						</UI_GridCell>
					))}
				</UI_Grid>
			</div>
		</div>
	);
};
